// extracted by mini-css-extract-plugin
export default {"routes":"AdminRoutes_routes__3DSm6","nav":"AdminRoutes_nav__oEoho","content":"AdminRoutes_content__UGOWh"};